var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"termly-policy-container"},[_c('div',{attrs:{"name":"termly-embed","data-id":_vm.termlyDataId,"data-type":"iframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }